import { useLayoutEffect } from "react";
//#region src/components/_overlay/toastClearance.ts
var PROPERTY = "--ds-toast-clearance";
/** Each container's claims, by the claiming footer. */
var claims = /* @__PURE__ */ new WeakMap();
function publish(container) {
	const own = claims.get(container);
	const largest = own && own.size > 0 ? Math.max(...own.values()) : 0;
	if (largest > 0) container.style.setProperty(PROPERTY, `${largest}px`);
	else container.style.removeProperty(PROPERTY);
}
/**
* Claims toast clearance for `footer`, a dialog footer inside a Layer, while it's mounted.
* Re-measured whenever the footer, its panel or the layer changes size, and after the
* panel's entry animation (which moves it while it runs).
*/
function useToastClearance(footer) {
	useLayoutEffect(() => {
		const layer = footer?.closest("[data-ds-layer]");
		const container = layer?.parentElement;
		if (!footer || !layer || !container) return;
		let own = claims.get(container);
		if (!own) claims.set(container, own = /* @__PURE__ */ new Map());
		const mine = own;
		const measure = () => {
			const space = layer.getBoundingClientRect().bottom - footer.getBoundingClientRect().top;
			mine.set(footer, Math.max(0, Math.ceil(space)));
			publish(container);
		};
		measure();
		const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
		for (const element of [
			footer,
			footer.parentElement,
			layer
		]) if (element) observer?.observe(element);
		layer.addEventListener("animationend", measure);
		return () => {
			observer?.disconnect();
			layer.removeEventListener("animationend", measure);
			mine.delete(footer);
			publish(container);
		};
	}, [footer]);
}
//#endregion
export { useToastClearance };

//# sourceMappingURL=toastClearance.js.map